import { render, staticRenderFns } from "./CartsDrawerLayout.vue?vue&type=template&id=55bf026a&scoped=true"
import script from "./CartsDrawerLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartsDrawerLayout.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CartsDrawerLayout.vue?vue&type=style&index=0&id=55bf026a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bf026a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoadingSpinner: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/LoadingSpinner.vue').default})
